<template>
    <div>
        <h4>Bestelltes Essen</h4>
        <hr class="top-hr-accent-color">
        <b-table
            striped
            hover
            show-empty
            small
            stacked="md"
            :items="menuItems"
            :fields="fields"
            class="order"
        >
            <template v-slot:cell(name)="row">
                <div style="font-size: 18px;">
                    <span :class="{'font-weight-bold' : true, 'is_maxi': row.item.is_maxi}">{{ row.item.categoryName }}:</span><br> {{ row.value }}
                </div>
            </template>
            <template v-slot:cell(price)="row">
                {{ row.value }} €
            </template>
            <template v-slot:cell(quantity)="row">
                <div class="quantity mx-2">{{ row.value }}</div>
            </template>
            <template v-slot:cell(total)="row">
                <div class="total">
                    {{ ((row.item.price * 100 * row.item.quantity) / 100).toFixed(2) }} €
                </div>
            </template>
        </b-table>
    </div>
</template>
<script>

export default {
    name:  'PreorderedMenu',
    props: {
        menuItems: {
            type:    Array,
            require: true,
        }
    },
    data() {
        return {
            fields: [
                {key: 'name', label: 'Name'},
                {key: 'price', label: 'Preis'},
                {key: 'quantity', label: ''},
                {key: 'total', label: 'Summe'},
            ],
        }
    }
}
</script>
